import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchText } from "../../../store/MassNotification";
import { selectSearchText } from "../../../store/MassNotification/selectors/selectSearchText";

export const UsersSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectSearchText);
  return (
    <IonSearchbar
      value={searchText}
      onIonChange={(e) => dispatch(setSearchText(e.detail.value || ""))}
      debounce={700}
      placeholder={"Buscar usuario..."}
      autocomplete="off"
    />
  );
};
